import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const OnboardingPage = lazy(() => import('./index'))
const OnboardingStep = lazy(() => import('./steps'))
export const onboardingRoutes = () => {
  return (
    <Route path={pageUrl.onboarding} element={<OnboardingPage />}>
      <Route path={pageUrl.onboardingStep} element={<OnboardingStep />} />
    </Route>
  )
}
